import React from "react";
import { withPersonalInfo } from "@/utils/withPersonalInfo";
import MobileHome from "@/pageComponents/mobileHome";
import WebHome from "@/pageComponents/webHome";
import { IResponseInitPPT } from "@/services/home/types";
import { getHomeData } from "@/services/home";
interface IProps {
  isMobile: boolean;
  isPersonal: boolean;
  initData: IResponseInitPPT["data"];
}

const Home: React.FC<IProps> = (props) => {
  const { isMobile, isPersonal, initData } = props;

  return isMobile ? (
    <MobileHome />
  ) : (
    <WebHome isPersonal={isPersonal} initData={initData} />
  );
};

export const getServerSideProps = withPersonalInfo<
  Partial<Pick<Omit<IProps, "isPersonal">, "initData">>
>(async (ctx) => {
  // 是否是移动端
  const userAgent = ctx.req.headers["user-agent"];
  const isMobile =
    /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Android|iP(ad|od|hone)/i.test(
      userAgent || ""
    );
  if (isMobile) {
    return {
      props: {
        isMobile,
      },
    };
  }
  const res = (await getHomeData()).data;
  return {
    props: {
      isMobile,
      initData: res.data,
    },
  };
});

export default Home;
